// extracted by mini-css-extract-plugin
module.exports = {"edge-wrapper":"icon-m__edge-wrapper__1LKN8","curve-wrapper":"icon-m__curve-wrapper__2ld1A"};